import { jsx as _jsx } from "react/jsx-runtime";
import { ConnectedDevices as ConnectedDevicesUi, DeviceProvider, } from "@madmedical/ui";
import { useMe } from "@madmedical/user";
import { invariant, isWeb } from "@madmedical/utils";
import { useDismissPersist } from "@madmedical/storage";
import useDevices from "../useDevices";
const ConnectedDevices = () => {
    const { patient } = useMe();
    const { devices, isLoading } = useDevices();
    const { visible: appDownloadVisible, dismiss: dismissAppDownload } = useDismissPersist("appDownloadAlert");
    if (isLoading) {
        return null;
    }
    invariant(patient);
    return (_jsx(DeviceProvider, Object.assign({ value: { devices: devices.filter((device) => device.isConnected) } }, { children: _jsx(ConnectedDevicesUi, { maxDeviceCount: patient.maxDeviceCount, showAppDownload: isWeb && appDownloadVisible, onDismissAppDownload: dismissAppDownload }) })));
};
export default ConnectedDevices;
